// Libs
import React, { Component } from 'react'
import classNames from 'classnames'
import axios from 'axios'

// CSS
import "./styles.scss"

class InputImage extends Component {
  state = {
    imageUrl: 'init'
  }

  componentDidMount() {
    const { image } = this.props
    const { fetchImage } = this

    fetchImage(image)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { image, value } = this.props
    const { image: nextImage, value: nextValue } = nextProps
    const { readAsDataURL, loadImage } = this

    if (value !== nextValue) {
      readAsDataURL(nextValue)
    }
  }

  fetchImage = (value) => {
    const { loadImage } = this

    axios.get(value)
      .then(response => {
        this.setState({ imageUrl: value })
      })
      .catch(e => {
        this.setState({ imageUrl: '' })
      })
  }

  readAsDataURL = (value) => {
    const { loadImage } = this
    const inputImage = this

    if (value && value[0]) {
      var reader = new FileReader()
      const { image, imageButton } = this.refs

      reader.onloadend = function () {
        inputImage.setState({ imageUrl: reader.result })
      }

      reader.readAsDataURL(value[0]);
    }
  }

  render() {
    const {
      meta: {
        touched,
        error,
      },
      type,
      label,
      placeholder,
      capitalize,
      secured,
      disabled,
      gutter,
      size,
      accept,
      image,
      handleBlur,
      handleDelete,
      handleEnter,
      input: { value, ...input }
    } = this.props
    const { imageUrl } = this.state
    const { readAsDataURL } = this

    readAsDataURL(value)

    return (
      <div style={{ margin: `${gutter / 2}px 0px` }} className="input-image">
        <div className="input-image__label">{label}</div>
        <label className="input-image__image" htmlFor="image">
          <div style={{ backgroundImage: `url(${imageUrl})` }} ref="image"></div>
          <p style={{ display: imageUrl ? `none` : 'flex' }} ref="imageButton">Inserir Imagem</p>
        </label>
        <input
          {...input}
          id="image"
          type="file"
          accept={accept}
          hidden />
      </div>
    )
  }
}

export default InputImage
